<template>
  <div>
    <c-modal
      :visible="visible"
      title="Share"
      size="lg"
      @close="close"
      @modelConfirm="handleModelConfirm"
    >
      <template slot="content">
        <my-form
          ref="overFormRef"
          :data="data"
          :loading="loading"
          :option="option"
          :footer-visible="false"
          width="auto"
        />
      </template>
    </c-modal>
  </div>
</template>

<script>
import CModal from '@/components/crud/modal.vue';
// import MyForm from '@/components/myForm/index.vue';
import { add } from '@/api/apply/share'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    CModal,
    MyForm: () => import('@/components/myForm/index.vue'),
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    processId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      loading: false,
      data: {},
    }
  },
  computed: {
    option() {
      const columns = [ // 列的其他配置可参考vue-good-table
        {
          label: 'Staff',
          field: 'recipientIds',
          formOption: { // 表单配置
            type: 'select',
            rules: 'required', // 规则参考vee-validate文档
            dictCode: 'staff',
            multiple: true,
          },
        },
      ]
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: true, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns,
      }
      return option
    },
  },
  methods: {
    async handleModelConfirm() {
      if (this.loading) { return }
      this.loading = true
      const params = await this.$refs.overFormRef.validationForm()
      if (params) {
        params.processId = this.processId
        if (Array.isArray(params.recipientIds)) {
          params.recipientIds = params.recipientIds.join()
        }
        add(params).then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.close()
        })
      } else {
        this.loading = false
      }
    },
    close() {
      this.loading = false
      this.$emit('update:visible', false)
    },
  },
}

</script>

<style lang='scss' scoped>

</style>
